<app-master-data-table [data]="this.masterCommonService.currenciesList" [columns]="currencyColumns"
  title="Currencies List" addButtonLabel="Currency" (add)="openAddUpdateCurrencyDialog('add')"
  (update)="openAddUpdateCurrencyDialog('update', $event)" (delete)="deleteCurrency($event)">
</app-master-data-table>